import React, { Component } from 'react'; //different
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import { isMobile } from 'react-device-detect';
import NavMenu from './navmenu';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            prolistx: [],
            username: null,
            userid: null,
            showmodal: false,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            loginstate: false,
            fullname: null,
            lname: null,
            alert: null,
            depositstate: 0,
            depositamount: 0,
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            affpercent: 0,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            tblnextrank: [],
            tblrankall: [],
            tblprofile: [],
            prodetail: [],
            linkaff: "",
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
            proderedeem: [],
            buttoncliam: false,
            limit: null,
            rankpic: null,
            rankname: null,
            rankob: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    
    confirmdeposit = async (e, num) => {

        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        await instance.post("/api/v1/getredeempromotion", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    proderedeem: res.data.message.tblpromotionredeems,
                });

            }
        }).catch(async (err) => {
        });

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                ////////console.log(depositstate, num);
                if (num === 0) {
                    if (token != null) {
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            ////////console.log(res.data.picture)
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("success", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    async componentDidMount() {
        this.promotionlist();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.setState({
                username: Username,
            });

        }
    }
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            //   console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                })
                window.location.href = '/';
            }
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("success", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    e.preventDefault();

                    await this.notify("success", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    return false;
                }
                else if (res.data.status === 202) {
                    e.preventDefault();

                    await this.notify("success", 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว');
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("success", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
    }

    checkpro = async (e, proid) => {
        console.log(248, proid);
        var token = localStorage.getItem('auth_token');
        if (token === null) {
            // ยังไม่ล็อคอิน → ไปหน้า login
            window.location.href = this.props.webnamex ? this.props.webnamex + '/signin' : '/signin';
            return;
        }
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("success", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await Swal.fire({
                        title: 'Success!',
                        text: 'ดำเนินการใช้คูปองเรียบร้อย',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    })
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("error", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("error", 'คุณไม่ได้ล๊อคอิน');
        }

    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "phoneNumber") {
                document.getElementById("phoneNumberforget").style = "";
                document.getElementById("checkotpforgetphone").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    render() {
        const { prodetail, picnonpro, username, prolistx } = this.state;
        return (
            <>
                <ToastContainer />
                <div style={{
                    color: '#fff',
                    background: 'linear-gradient(180deg, #1a1209 0%, #0d0d0d 100%)',
                    minHeight: '100vh',
                    paddingBottom: '80px'
                }}>
                    {/* Header */}
                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '12px 16px',
                        background: 'linear-gradient(180deg, rgba(30,20,5,0.98) 0%, rgba(15,10,3,0.95) 100%)',
                        borderBottom: '1px solid rgba(236,202,119,0.2)',
                        position: 'sticky', top: 0, zIndex: 100
                    }}>
                        <a role="button" href='/home' style={{ color: '#ECCA77', lineHeight: 1 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                            </svg>
                        </a>
                        <div style={{ color: '#FBDEB2', fontSize: '16px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <img src="/idea-bet.live/theme/ufa7/images/menu/icn-menu-rewards.svg" style={{ width: 18, height: 18 }} alt="" />
                            โปรโมชั่น
                        </div>
                        <div style={{ width: 22 }} />
                    </div>

                    <div style={{ maxWidth: '480px', margin: '0 auto', padding: '16px' }}>

                        {/* Coupon Section */}
                        <div style={{
                            background: 'linear-gradient(135deg, #2a1f0a 0%, #1a1209 100%)',
                            border: '1px solid rgba(236,202,119,0.25)',
                            borderRadius: '16px',
                            padding: '16px',
                            marginBottom: '16px'
                        }}>
                            <div style={{ color: '#ECCA77', fontSize: '13px', fontWeight: '600', marginBottom: '10px' }}>
                                โค้ดโปรโมชั่น
                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <input
                                    type="text"
                                    onChange={this.onChangex}
                                    id="couponkey"
                                    name="couponkey"
                                    placeholder="กรอกโค้ดที่นี่"
                                    style={{
                                        flex: 1,
                                        background: 'rgba(0,0,0,0.4)',
                                        border: '1px solid rgba(236,202,119,0.3)',
                                        borderRadius: '10px',
                                        padding: '10px 14px',
                                        color: '#FBDEB2',
                                        fontSize: '14px',
                                        outline: 'none'
                                    }}
                                />
                                <button
                                    onClick={(e) => this.couponredeem(e)}
                                    style={{
                                        background: 'linear-gradient(180deg, #f9cf95 0%, #c69a5d 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        padding: '10px 18px',
                                        color: '#1a0a00',
                                        fontWeight: '700',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        display: username !== null ? '' : 'none',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    ยืนยัน
                                </button>
                            </div>
                            <div style={{ color: 'rgba(251,222,178,0.5)', fontSize: '11px', marginTop: '8px' }}>
                                กดรับที่โปรโมชั่น โปรโมชั่นจะเข้าอัตโนมัติเมื่อเติมเงิน
                            </div>
                        </div>

                        {/* Section title */}
                        <div style={{ color: '#ECCA77', fontSize: '13px', fontWeight: '600', marginBottom: '12px' }}>
                            โปรโมชั่นทั้งหมด
                            <span style={{ color: 'rgba(251,222,178,0.4)', fontSize: '11px', fontWeight: '400', marginLeft: '8px' }}>
                                เพียงฝากให้ยอดตรงกับเงื่อนไข รับโปรทันที
                            </span>
                        </div>

                        {/* Promotion Grid */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            {prolistx.map((prolists, i) => (
                                <a
                                    key={i}
                                    href="#0"
                                    onClick={(e) => this.checkpro(e, prolists.no)}
                                    style={{ textDecoration: 'none', display: 'block' }}
                                >
                                    <div style={{
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        border: '1px solid rgba(236,202,119,0.15)',
                                        background: '#1a1209',
                                        transition: 'transform 0.2s, box-shadow 0.2s'
                                    }}
                                        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(236,202,119,0.15)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                                    >
                                        <img
                                            src={prolists.linkpicture}
                                            alt={prolists.proname}
                                            style={{ width: '100%', display: 'block', objectFit: 'cover' }}
                                        />
                                        <div style={{
                                            padding: '8px 10px',
                                            color: '#FBDEB2',
                                            fontSize: '11px',
                                            lineHeight: '1.4',
                                            fontWeight: '500'
                                        }}>
                                            {prolists.proname}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Modal */}
                    {this.state.showmodal && (
                        <div
                            style={{
                                position: 'fixed', inset: 0, zIndex: 9999,
                                background: 'rgba(0,0,0,0.75)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                padding: '16px'
                            }}
                            onClick={(e) => { if (e.target === e.currentTarget) this.setState({ showmodal: false }); }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #1e1407 0%, #0d0d0d 100%)',
                                border: '1px solid rgba(236,202,119,0.3)',
                                borderRadius: '20px',
                                width: '100%',
                                maxWidth: '400px',
                                maxHeight: '85vh',
                                overflowY: 'auto',
                                position: 'relative'
                            }}>
                                <button
                                    onClick={() => this.setState({ showmodal: false })}
                                    style={{
                                        position: 'absolute', top: 10, right: 12,
                                        background: 'rgba(0,0,0,0.5)', border: 'none',
                                        borderRadius: '50%', width: 30, height: 30,
                                        color: '#ECCA77', fontSize: '16px', cursor: 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        zIndex: 1, lineHeight: 1
                                    }}
                                >✕</button>

                                {prodetail.length === 0 ? (
                                    <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                                        <img src={picnonpro} alt="" style={{ width: '100%', borderRadius: '12px', marginBottom: '16px' }} />
                                        <div style={{ color: 'rgba(251,222,178,0.6)', fontSize: '14px' }}>โปรโมชั่นยังไม่ได้เปิดใช้งาน</div>
                                    </div>
                                ) : (
                                    <div>
                                        <img
                                            src={prodetail.linkpicture}
                                            alt=""
                                            style={{ width: '100%', display: 'block', borderRadius: '20px 20px 0 0' }}
                                        />
                                        <div style={{ padding: '16px' }}>
                                            {prodetail.prolist !== 5 && username && (
                                                <button
                                                    onClick={(e) => this.redeempro(e, prodetail.no)}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(180deg, #f9cf95 0%, #c69a5d 100%)',
                                                        border: 'none', borderRadius: '30px',
                                                        padding: '12px', color: '#1a0a00',
                                                        fontWeight: '700', fontSize: '15px',
                                                        cursor: 'pointer', marginBottom: '14px',
                                                        boxShadow: '0 4px 12px rgba(249,207,149,0.3)'
                                                    }}
                                                >
                                                    รับโปรโมชั่น
                                                </button>
                                            )}
                                            <div style={{
                                                background: 'rgba(0,0,0,0.3)',
                                                border: '1px solid rgba(236,202,119,0.15)',
                                                borderRadius: '10px', padding: '12px'
                                            }}>
                                                <div style={{ color: '#ECCA77', fontSize: '12px', fontWeight: '600', marginBottom: '8px' }}>
                                                    ข้อตกลงและเงื่อนไข
                                                </div>
                                                <div style={{ color: 'rgba(251,222,178,0.7)', fontSize: '13px', lineHeight: '1.7' }}>
                                                    <section dangerouslySetInnerHTML={{ __html: prodetail.detail }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
export default App;
